"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingPageCard = void 0;
const react_1 = __importDefault(require("react"));
const polaris_1 = require("@shopify/polaris");
const polaris_icons_1 = require("@shopify/polaris-icons");
const DateFormat_1 = require("components/general/utility/DateFormat");
const styles_1 = require("./styles");
function textWithLineBreaks(text) {
    return text.split('\n').map((line, index) => (react_1.default.createElement(react_1.default.Fragment, { key: index },
        line,
        index !== text.length - 1 && react_1.default.createElement("br", null))));
}
const TrackingPageCard = ({ popoverIsActive, published, trackingPage, onClosePopover, onOpenDeleteModal, onOpenPopover, onSetDefaultAction }) => {
    const title = trackingPage.isDefault ? (react_1.default.createElement(polaris_1.LegacyStack, { spacing: 'tight' },
        react_1.default.createElement(polaris_1.Text, { as: 'h2', variant: 'headingMd' }, trackingPage.title),
        react_1.default.createElement(polaris_1.Tooltip, { content: 'This page is set as your default tracking URL' },
            react_1.default.createElement(polaris_1.Icon, { source: polaris_icons_1.StarFilledIcon, tone: 'subdued' })))) : (trackingPage.title);
    return (react_1.default.createElement(polaris_1.LegacyCard, { title: title },
        react_1.default.createElement(polaris_1.LegacyCard.Section, null,
            react_1.default.createElement(polaris_1.Popover, { activator: react_1.default.createElement(polaris_1.Button, { accessibilityLabel: 'More actions', icon: polaris_icons_1.MenuHorizontalIcon, onClick: () => onOpenPopover(trackingPage), variant: 'monochromePlain' }), active: popoverIsActive, autofocusTarget: 'first-node', onClose: onClosePopover },
                react_1.default.createElement(polaris_1.ActionList, { actionRole: 'menuitem', items: [
                        {
                            content: 'Set as default tracking page URL',
                            onAction: () => onSetDefaultAction(trackingPage.url),
                            disabled: !published
                        },
                        {
                            content: 'Delete',
                            onAction: () => onOpenDeleteModal(trackingPage)
                        }
                    ] })),
            react_1.default.createElement("div", { style: { marginBottom: '0.5rem' } },
                react_1.default.createElement(polaris_1.Text, { as: 'p', tone: 'subdued', variant: 'bodyMd' }, `Created ${(0, DateFormat_1.shortDateFormat)(trackingPage.insertedAt)}`)),
            trackingPage.description && (react_1.default.createElement(polaris_1.Text, { as: 'p', breakWord: true, variant: 'bodyMd' }, textWithLineBreaks(trackingPage.description))),
            react_1.default.createElement(styles_1.Group, null,
                react_1.default.createElement(polaris_1.InlineStack, { blockAlign: 'center', gap: '100' },
                    react_1.default.createElement(polaris_1.Text, { as: 'span' }, "Preview:"),
                    react_1.default.createElement(polaris_1.Link, { target: '_blank', url: trackingPage.url }, trackingPage.url))),
            react_1.default.createElement(styles_1.Group, null,
                react_1.default.createElement(polaris_1.Button, { external: true, icon: polaris_icons_1.ExternalIcon, url: trackingPage.shopifyEditUrl }, "Customize My Page")))));
};
exports.TrackingPageCard = TrackingPageCard;
